import { ArrowUp, ArrowDown, Minus } from '@phosphor-icons/react';
import { hormoneRanges } from '../constants/hormoneData';

// Calculate hormone status based on value
export const getHormoneStatus = (hormone, value) => {
  if (!value || !hormoneRanges[hormone]) return { status: 'unknown', color: '#94A3B8' };
  const range = hormoneRanges[hormone];
  
  if (value < range.min * 0.5) return { status: 'critically_low', color: '#DC2626', icon: ArrowDown };
  if (value < range.min) return { status: 'low', color: '#F97316', icon: ArrowDown };
  if (value > range.max * 1.5) return { status: 'critically_high', color: '#DC2626', icon: ArrowUp };
  if (value > range.max) return { status: 'high', color: '#F97316', icon: ArrowUp };
  return { status: 'normal', color: '#10B981', icon: Minus };
};

// Get status label for display
export const getStatusLabel = (status) => {
  switch (status) {
    case 'normal': return 'Normal';
    case 'low': return 'Low';
    case 'high': return 'Elevated';
    case 'critically_low': return 'Critical';
    case 'critically_high': return 'Critical';
    default: return '—';
  }
};

// Validate hormone values for warnings
export const validateHormones = (hormones) => {
  if (!hormones) return [];
  const warnings = [];
  
  if (hormones.fsh && (hormones.fsh < 0.1 || hormones.fsh > 200)) {
    warnings.push(`FSH value of ${hormones.fsh} mIU/mL appears unusual. Typical range is 3.5-12.5 mIU/mL in reproductive years.`);
  }
  if (hormones.amh && hormones.amh > 15) {
    warnings.push(`AMH value of ${hormones.amh} ng/mL is very high. Please verify this value from your lab report.`);
  }
  if (hormones.estradiol && hormones.estradiol > 1000) {
    warnings.push(`Estradiol value of ${hormones.estradiol} pg/mL is unusually high. Please verify.`);
  }
  
  return warnings;
};
